// ----------------------------------------------------------------------- imports externos
import Swal from "sweetalert2";

// ----------------------------------------------------------------------- imports internos
import { useAuth } from "../../auth/AuthContext";
import Buscador from "./Buscador";
import { CampanaSalidas } from "../vigilancia/SalidaPendiente";
import { MARCA } from "../../marca";

/* Cabecera del hub: el buscador, quién sos, y las acciones.
 *
 * ── EL TÍTULO DE LA PANTALLA YA NO ESTÁ ACÁ ──────────────────────────────
 *
 * Lo dibuja `Cabeza`, arriba del contenido — y hasta hoy lo dibujaban LOS DOS.
 * Cada uno con su propia función `tituloDe`, que además no coincidían: la de
 * `Cabeza` no conocía `/cambiar-password` ni `/recursos`, así que en esas dos
 * la barra mostraba el título y el contenido abría sin ninguno.
 *
 * El nombre de la pantalla repetido dos veces no rompe nada, y es exactamente
 * lo que hace que una aplicación se lea como dos pegadas: es la misma costura
 * que FlotaBot sacó de adentro de sus paneles con `data-embebido`.
 *
 * Lo que sí es de acá es la MARCA, y sólo con el rail plegado —que es cuando
 * no está en ningún otro lado—. Con el rail abierto ya la dibuja él.
 *
 * Y de paso, el buscador se quedó con el ancho que ocupaba el título, que es
 * donde más falta le hacía.
 */

const Header = ({
  plegado,
  onPlegar,
  onAbrirPreferencias,
  verComo = null,
  permisos = null,
}) => {
  const { logout, fullUser } = useAuth();

  const handleLogout = async () => {
    const result = await Swal.fire({
      title: "¿Cerrar sesión?",
      text: "Vas a salir de la aplicación",
      icon: "warning",
      showCancelButton: true,
      backdrop: "rgba(0, 0, 0, 0.8)",
      confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "var(--acc, #1B4D8F)",
      cancelButtonColor: "transparent",
      customClass: { cancelButton: "swal-cancel-btn" },
    });
    if (result.isConfirmed) await logout();
  };

  const inicial = (fullUser?.nombres || "?").trim().charAt(0).toUpperCase();

  return (
    <>
      <header className="hub-cabecera">
        {plegado && (
          <button
            className="hub-boton-icono"
            onClick={onPlegar}
            aria-label="Abrir menú"
            title="Abrir menú"
          >
            ☰
          </button>
        )}
        {/* ACÁ YA NO VA EL TÍTULO DE LA PANTALLA. Lo dibuja `Cabeza`, arriba
            del contenido, y hasta hoy lo dibujaban LOS DOS: el nombre de la
            sección aparecía dos veces, con dos funciones distintas que además
            no coincidían en las pantallas de respaldo.

            La marca se muestra SÓLO CON EL RAIL PLEGADO, que es exactamente
            cuando no está en ningún otro lado: con el rail abierto ya la
            dibuja él, y repetirla sería volver a lo mismo que acabamos de
            sacar. */}
        {plegado && <div className="hub-titulo hub-marca-chica">{MARCA}</div>}

        {/* EL BUSCADOR VA EN LA CABECERA Y NO EN UNA PANTALLA, y eso es lo que
            lo hace servir: la pregunta «¿qué pasa con el 774?» aparece estando
            en cualquier lado, y si para buscar hay que ir primero a la
            pantalla de buscar, se sigue haciendo por teléfono. */}
        <Buscador permisos={permisos} />

        <div className="hub-quien">
          {/* Sólo lo recibe la cuenta del dueño; para el resto llega null y
              acá no se dibuja nada. La decisión de quién puede vive en
              `services/verComo`, no repartida por la cabecera. */}
          {verComo}
          {/* Salidas del personal que quedaron sin registrar (ticket 417).
              Sólo aparece si hay alguna. */}
          <CampanaSalidas />
          <button
            className="hub-boton-icono"
            onClick={onAbrirPreferencias}
            aria-label="Preferencias"
            title="Preferencias"
          >
            ⚙
          </button>
          {fullUser && (
            /* Antes esto abría la ficha. Se sacó: el panel que abría se
               superponía con el de preferencias, y sin poder editar no decía
               nada que no esté ya adentro de Preferencias. Queda como etiqueta,
               que es para lo único que servía — saber con qué cuenta estás. */
            <span className="hub-persona hub-persona--fija">
              <span className="hub-inicial">{inicial}</span>
              {fullUser.nombres}
            </span>
          )}
          <button
            className="hub-boton-icono"
            onClick={handleLogout}
            aria-label="Cerrar sesión"
            title="Cerrar sesión"
          >
            ✕
          </button>
        </div>
      </header>

    </>
  );
};

export default Header;
